export default {"src":"/stays/_next/static/media/AccuracyOfPhotos.9d2affad.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};